import React, { useEffect } from "react";
import BlogCard from "../components/Blog/BlogCard";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { getArticles } from "../features/blog";
import { Banner } from "../components/common/Banner";


const Blog: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const dispatch = useAppDispatch();
    const { articles } = useAppSelector((state) => state.blog);
    useEffect(() => {
        dispatch(getArticles());
    }, [dispatch])
    return (
        <>
            <Banner banner_title={banner_title} />
            <BlogCard articles={articles} />
        </>
    )
}
export default Blog;